import { useDiscoverActions, useDiscoverContext } from "../state/discover-context";
import type { ChatMapSize } from "../types";

/**
 * How wide the map runs beside the AI Chat. The chat leads by default — the
 * picks are the answer to the question that was asked — but placing them is
 * exactly what the map is for, so the width is the guest's to set.
 *
 * One control: the "Expand map" segment in the chat header's toolbar, which
 * steps through the widths. That segment lives in the app, beside the other
 * two it shares a capsule with; only the state lives here.
 *
 * There used to be a second control — three bars in the map's own corner — and
 * two ways to set one value is one too many when they sit on the same screen.
 * It was removed (owner, 2026-09-10).
 */
export const CHAT_MAP_SIZES: readonly ChatMapSize[] = ["slim", "half", "wide"];

const NEXT: Record<ChatMapSize, ChatMapSize> = {
  slim: "half",
  half: "wide",
  wide: "slim",
};

export function useChatMapSize() {
  const { state } = useDiscoverContext();
  const { setChatMapSize } = useDiscoverActions();
  return {
    size: state.chatMapSize,
    setSize: setChatMapSize,
    cycle: () => setChatMapSize(NEXT[state.chatMapSize]),
  };
}
